import {v4 as uuidv4} from 'uuid';

const testimonialOneData = [
  {
    id: uuidv4(),
    name: 'Mohammed R.',
    designation: 'Homeowner, Dubai',
    timeAgo: '1 week ago',
    speech: 'Dhtech fixed my AC cooling issue the same day I called. The technicians were professional, explained everything clearly, and the pricing was transparent with no hidden charges. Highly recommend!',
  },
  {
    id: uuidv4(),
    name: 'Sara K.',
    designation: 'Facilities Manager, Abu Dhabi',
    timeAgo: '2 weeks ago',
    speech: 'We use Dhtech for regular AC maintenance across our offices and they have been outstanding. Their team responds quickly, keeps our systems running efficiently, and their 24/7 support has saved us from several emergencies.',
  },
  {
    id: uuidv4(),
    name: 'Ahmed Al Mansoori',
    designation: 'Villa Owner, Sharjah',
    timeAgo: '3 weeks ago',
    speech: 'Excellent service! The team arrived on time, diagnosed the problem quickly, and had our AC running perfectly within the hour. Very professional and reasonably priced. Will definitely use again.',
  },
  {
    id: uuidv4(),
    name: 'Priya S.',
    designation: 'Apartment Resident, Dubai',
    timeAgo: '1 month ago',
    speech: 'Amazing results! Dhtech transformed our old, inefficient AC system. They were thorough, tidy, and kept us informed throughout. The whole process was smooth and efficient. 5 stars!',
  },
  {
    id: uuidv4(),
    name: 'James W.',
    designation: 'Office Manager, Dubai',
    timeAgo: '1 month ago',
    speech: 'Best AC service company in UAE. Fast response, skilled technicians, and fair prices. Our central HVAC system has been running flawlessly since their maintenance visit. Highly recommended!',
  },
  {
    id: uuidv4(),
    name: 'Fatima Al Hashmi',
    designation: 'Homeowner, Ajman',
    timeAgo: '6 weeks ago',
    speech: 'Very impressed with the professionalism and expertise of the Dhtech team. They completed our AC duct cleaning thoroughly and the air quality in our home has improved significantly. Great service!',
  },
];

export default testimonialOneData;
